define('modules/button/button_view',[
  'backbone',
  'jquery',
  '_',

  './button_model',
  'text!./button_template.html'
], function (Backbone, $, _,
             ButtonModel,
             button_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.model = new ButtonModel({label: this.label, label_text: this.label_text, icon: opts.icon});
      this.render();

      this.el.href = this.href || '#';

      if (this.size) {
        this.$el.addClass('button-' + this.size);
      }

      if (this.type) {
        this.$el.addClass('button-' + this.type);
      }

      if (this.return_to) {
        this.$el.data().returnTo = this.return_to;
      }

      if(this.data) {
        this.$el.data(this.data);
      }

    },

    template: _.template(button_template),
    events: {
      'click': 'clickHandler'
    },

    clickHandler: function (e) {
      if(this.onClick) {
        e.preventDefault();
        this.onClick();
      }
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    tagName: 'a',
    className: 'button',

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    }
  });
  return View;
});

